/**
 * Shared magnitude → colour scale for earthquake map dots, popups, and legend.
 * USGS feed is M4.5+, but the display scale starts at M4 (light) so the weakest
 * events in the feed are not pinned to 0% on the meter.
 */
export const SEISMIC_MAG_MIN = 4;
export const SEISMIC_MAG_MAX = 8.5;

const SEISMIC_RGB_LOW = { r: 247, g: 220, b: 111 }; /* #f7dc6f */
const SEISMIC_RGB_HIGH = { r: 211, g: 84, b: 0 }; /* #d35400 */

export const SEISMIC_COLOR_LOW = '#f7dc6f';
export const SEISMIC_COLOR_HIGH = '#d35400';
export const SEISMIC_GRADIENT_CSS = `linear-gradient(90deg, ${SEISMIC_COLOR_LOW}, ${SEISMIC_COLOR_HIGH})`;

function clamp01(v: number): number {
  return Math.max(0, Math.min(1, v));
}

/** 0 at M4 (light), 1 at M8.5+ (major) — same scale for dots and meter position. */
export function seismicMagnitudeT(mag: number): number {
  return clamp01((mag - SEISMIC_MAG_MIN) / (SEISMIC_MAG_MAX - SEISMIC_MAG_MIN));
}

export function seismicColorForMagnitude(mag: number): string {
  const t = seismicMagnitudeT(mag);
  const r = Math.round(SEISMIC_RGB_LOW.r + (SEISMIC_RGB_HIGH.r - SEISMIC_RGB_LOW.r) * t);
  const g = Math.round(SEISMIC_RGB_LOW.g + (SEISMIC_RGB_HIGH.g - SEISMIC_RGB_LOW.g) * t);
  const b = Math.round(SEISMIC_RGB_LOW.b + (SEISMIC_RGB_HIGH.b - SEISMIC_RGB_LOW.b) * t);
  return `#${[r, g, b]
    .map((c) => c.toString(16).padStart(2, '0'))
    .join('')}`;
}

/** Bar fill width % aligned with `seismicMagnitudeT`. */
export function seismicMagnitudeBarPercent(mag: number): number {
  return Math.round(seismicMagnitudeT(mag) * 100);
}
